import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { useRecolectoresMutations } from '../../hooks'
import { FooterPages } from '..';
import Select from 'react-select';
import {getComunas} from "../../services/Comunas";
import { getRecolectoresRut, getRecolectoresEmail } from "../../services/Recolectores";
import {getCentrosCompostajes} from "../../services/CentrosCompostaje";

import rutValidator from '../../utils/validateRut';
import {Toaster, toast} from 'react-hot-toast';

const initialState = {
  empresa:'',
  rut: '',
  nombreRecolector: '',
  direccion: '',
  telefono: '',
  email: '',
  descripcion: '',
  idComuna: '',
  nombreCiudad: '',
  contacto: '',
  numeroLicencia: '',
  patente: '',
  comunasAsignadas: [],
  centrosAsignados: [],
  estado: 'Activo',
};

const NuevoRecolector = ({vecinoData, onChangeVecino}) => {
  const { isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [comunaData, setComunaData] = useState([]);
  const [comunaDetalle, setComunaDetalle] = useState([]);
  const [comunaSeleccionada, setComunaSeleccionada] = useState(null);

  const [centroData, setCentroData] = useState([]);
  const [centroDetalle, setCentroDetalle] = useState([]);
  const [centroSeleccionada, setCentroSeleccionada] = useState(null);

  const { addRecolector, updateRecolectorD } = useRecolectoresMutations();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if(vecinoData) {
      setFormData(vecinoData);
      setComunaDetalle(vecinoData.comunasAsignadas);
      setCentroDetalle(vecinoData.centrosAsignados);
    }
  }, [vecinoData]);

 useEffect(()=>{
    const fetchData = async () => {
      const misComunas = await getComunas();
      setComunaData(misComunas);
      const misCentros = await getCentrosCompostajes();
      setCentroData(misCentros);
    };
    fetchData();
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const comunaOptions = comunaData.map((item) => ({
    value: item._id,
    label: `${item.codigoComuna} - ${item.nombreComuna}`,
  }));

  const centroOptions = centroData.map((item) => ({
    value: item._id,
    label: `${item.codigo} - ${item.nombreCentro}`,
  }));

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones
    if( !rutValidator(formData.rut))
    {
      toast.error('RUT ingresado no es válido!');
      return;
    }
    if (formData.rut === '') {
      toast.error('Debe ingresar un RUT válido.');
      return;
    }
    if (formData.nombreRecolector === '') {
      toast.error('Debe ingresar un nombre para el partner.');
      return;
    }
    if (formData.direccion === '') {
      toast.error('Debe ingresar una dirección.');
      return;
    }
    if (formData.telefono === '') {
      toast.error('Debe ingresar un número de teléfono.');
      return;
    }
    if (formData.email === '') {
      toast.error('Debe ingresar un correo electrónico.');
      return;
    }
    if (formData.idComuna === '') {
      toast.error('Debe seleccionar una comuna.');
      return;
    }
    if (comunaDetalle.length === 0) {
      toast.error('Debe agregar al menos una comuna.');
      return;
    }
    if (centroDetalle.length === 0) {
      toast.error('Debe agregar al menos un centro de compostaje.');  
      return;
    }

    const dataToSave = {
      ...formData,
      comunasAsignadas: comunaDetalle.map(c => ({
        idComunaA: c.idComunaA,
      })),
      centrosAsignados: centroDetalle.map(c => ({
        idCentro: c.idCentro,
      })),
    };

    if(!vecinoData._id) 
    {
        const existeRecolector = await getRecolectoresRut(formData.rut);
        if (existeRecolector.length > 0) {
          toast.error('Ya existe un recolector con el mismo RUT.');
          return;
        }

        const existeMail = await getRecolectoresEmail(formData.email);
        if (existeMail.length > 0) {
          toast.error('Ya existe un recolector con el mismo Email.');
          return;
        }

       await addRecolector.mutateAsync( dataToSave );
    } else
    { 
       await updateRecolectorD.mutateAsync( dataToSave );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevamaquina );
  }


  return (
    <form  onSubmit={handleSubmit} >
       <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-3/4 p-8">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">

            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
                <p className="text-gray-800 font-semibold text-base md:text-lg">
                  {!vecinoData ? "Nuevo" : "Editar"} Partner
                </p>
              </div>

              <button
                  type="button"
                  onClick={() => setIsClicked(!isClicked.nuevamaquina)}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
                  aria-label="Cerrar"
                >
                <MdOutlineCancel className="text-xl md:text-2xl" />
              </button>
          </div>

          <div className="mt-5 space-y-4">
              <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4" >
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Rut</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="rut"
                        value= {formData.rut}
                        required
                        onChange={handleChange}
                      />
                  </div>
                  <div className="col-span-2">
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Nombre</label>
                      <input
                          className={inputClass}
                          type="text"
                          placeholder=""
                          name="nombreRecolector"
                          value= {formData.nombreRecolector}
                          required
                          onChange={handleChange}
                        />
                    </div>
                  </div>
                  <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Dirección</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="direccion"
                        value= {formData.direccion}
                        required
                        onChange={handleChange}
                      />
                  </div>
                  </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2" >
              <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Teléfono</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="telefono"
                        value= {formData.telefono}
                        required
                        onChange={handleChange}
                      />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Mail</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="email"
                        value= {formData.email}
                        required
                        onChange={handleChange}
                      />
                  </div>


                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Comuna</label>
                    <Select
                      options={comunaOptions}
                      value={comunaOptions.find((option) => option.value === formData.idComuna)}
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          const comunaSeleccionada = comunaData.find(c => c._id === selectedOption.value);

                          setFormData((prev) => ({
                            ...prev,
                            idComuna: selectedOption.value,
                            nombreCiudad: comunaSeleccionada?.nombreCiudad || '',
                          }));
                        } else {
                          // Si se limpia el campo
                          setFormData((prev) => ({
                            ...prev,
                            idComuna: '',
                            nombreCiudad: '',
                          }));
                        }
                      }}
                      className="text-xs"
                      placeholder="Buscar ..."
                      isClearable
                      disabled = {!vecinoData._id ? false : true}
                    />

                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Ciudad</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="nombreCiudad"
                        value= {formData.nombreCiudad}
                        disabled
                        onChange={handleChange}
                      />
                  </div>

                </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2" >
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">N° Licencia</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="numeroLicencia"
                        value= {formData.numeroLicencia}
                        required
                        onChange={handleChange}
                      />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Patente</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="patente"
                        value= {formData.patente}
                        required
                        onChange={handleChange}
                      />
                  </div>


                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Estado</label>
                      <select className="text-xs border border-gray-300 p-2 rounded" name="estado" value= {formData.estado} required onChange={handleChange}>
                        <option value="Activo">Activo</option>
                        <option value="Inactivo">Inactivo</option>
                        <option value="Eliminado">Eliminado</option>
                      </select>
                  </div>

              </div>    

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-2" >
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Observación</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="descripcion"
                        value= {formData.descripcion}
                        required
                        onChange={handleChange}
                      />
                  </div>
                </div>  
                <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mt-2" >
                  <div className="flex flex-col">
                    <div className="col-span-2">
                        <label className="text-xs font-semibold mb-1">Agregar Comuna</label>
                        <div className="flex gap-2 items-center">
                          <div className="flex-1">
                            <Select
                              options={comunaOptions}
                              value={comunaSeleccionada}
                              onChange={setComunaSeleccionada}
                              className="text-xs"
                              placeholder="Buscar comuna..."
                              isClearable
                            />
                          </div>
                          <button
                            type="button"
                            className="text-xs bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded"
                            onClick={() => {
                              if (
                                comunaSeleccionada &&
                                !comunaDetalle.some(c => c.idComunaA === comunaSeleccionada.value)
                              ) {
                                const dataComuna = comunaData.find(c => c._id === comunaSeleccionada.value);
                                const nuevaComuna = {
                                  idComunaA: dataComuna._id,
                                  codigoComuna: dataComuna.codigoComuna,
                                  nombreComuna: dataComuna.nombreComuna,
                                  nombreCiudad: dataComuna.nombreCiudad,
                                };
                                setComunaDetalle(prev => [...prev, nuevaComuna]);
                                setComunaSeleccionada(null); // limpiar selector
                              }
                            }}
                            
                          >
                            Agregar
                          </button>
                        </div>
                    </div>

                      <div className="col-span-4 mt-2">
                        <label className="text-xs font-semibold mb-1">Comunas Asignadas</label>
                        <ul className="text-xs space-y-1">
                          {comunaDetalle && comunaDetalle.map((comuna, idx) => (
                            <li key={comuna.idComunaA} className="flex justify-between items-center bg-gray-100 px-3 py-1 rounded">
                              <span>{comuna.codigoComuna} - { comuna.nombreComuna} ({comuna.nombreCiudad})</span>
                              <button
                                type="button"
                                onClick={() => {
                                  const nuevaLista = comunaDetalle.filter((_, i) => i !== idx);
                                  setComunaDetalle(nuevaLista);
                                }}
                                
                                className="text-red-500 hover:text-red-700"
                              >
                                Quitar
                              </button>
                            </li>
                          ))}
                          {!formData.comunasAsignadas && (
                            <li className="text-gray-400 italic">Sin comunas asignadas</li>
                          )}
                        </ul>
                      </div>
                  </div>
                  <div className="flex flex-col"> 
                      <div className="col-span-2">
                        <label className="text-xs font-semibold mb-1">Agregar Centro de Compostaje</label>
                        <div className="flex gap-2 items-center">
                          <div className="flex-1">
                            <Select
                              options={centroOptions}
                              value={centroSeleccionada}
                              onChange={setCentroSeleccionada}
                              className="text-xs"
                              placeholder="Buscar Centro..."
                              isClearable
                            />
                          </div>
                          <button
                            type="button"
                            className="text-xs bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded"
                            onClick={() => {
                              if (
                                centroSeleccionada &&
                                !centroDetalle.some(c => c.idCentro === centroSeleccionada.value)
                              ) {
                                const dataCentro = centroData.find(c => c._id === centroSeleccionada.value);
                                const nuevaCentro = {
                                  idCentro: dataCentro._id,
                                  codigo: dataCentro.codigo,
                                  nombreCentro: dataCentro.nombreCentro,
                                };
                                setCentroDetalle(prev => [...prev, nuevaCentro]);
                                setCentroSeleccionada(null); // limpiar selector
                              }
                            }}
                            
                          >
                            Agregar
                          </button>
                        </div>
                    </div>

                      <div className="col-span-4 mt-2">
                        <label className="text-xs font-semibold mb-1">Centros Compostaje Asignados</label>
                        <ul className="text-xs space-y-1">
                          {centroDetalle && centroDetalle.map((centro, idx) => (
                            <li key={centro.idCentro} className="flex justify-between items-center bg-gray-100 px-3 py-1 rounded">
                              <span>{centro.codigo} - { centro.nombreCentro} </span>
                              <button
                                type="button"
                                onClick={() => {
                                  const nuevaLista = centroDetalle.filter((_, i) => i !== idx);
                                  setCentroDetalle(nuevaLista);
                                }}
                                
                                className="text-red-500 hover:text-red-700"
                              >
                                Quitar
                              </button>
                            </li>
                          ))}
                          {!formData.centrosAsignados && (
                            <li className="text-gray-400 italic">Sin centros de compostaje asignados</li>
                          )}
                        </ul>
                      </div>
                </div>
              </div>

              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                  <button
                      onClick={handleSubmit}
                      className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                  >
                    { !vecinoData ? "Crear Nuevo": "Guardar Cambios"}
                  </button>
              </div>    
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />         
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevoRecolector;